import { Component, OnInit } from '@angular/core';
import { ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridApi, GridOptions, GridReadyEvent, ITooltipParams, PaginationChangedEvent } from 'ag-grid-community';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { environment } from 'src/environments/environment';


const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;
@Component({
  selector: 'app-smart-router',
  templateUrl: './smart-router.component.html',
  styleUrls: ['./smart-router.component.scss']
})
export class SmartRouterComponent implements OnInit {

  selectedProduct : any;
  selectedCountry : any;
  productList : any[];
  countryList : any[];
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public permissions: any = '';
  globalSearch: string = '';
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public pageNumber: number;
  private filterObj: any = {};
  public rowData : any[];
  ellipses: boolean = true;
  maxSize: number;
  collectiondata: number = 0;
  collectionSize: number = 0;
  currentPage: number = 1;
  public gridOptions: GridOptions;
  formula : any;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 110,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true,
    lockVisible : true
  };

  public columnDefs: ColDef[] = [
    { field: 'name',  headerName: 'Service Provider', cellClass: 'grid-cell-centered'},
    { field: 'countryName', headerName: 'Product', },
    { field: 'description',  headerName: 'country', },
    { field: 'description',  headerName: 'Priority', },
    { field: 'contact',  headerName: 'Failed Count', },
    { field: 'email',headerName: 'Remaining Balance' },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'countryName', headerName: 'Total Balance', },
    { field: 'countryName', headerName: 'Remaining Transaction', },
    { field: 'status', headerName: 'Status', },
    {
      field: 'actions',lockVisible:true,sortable: false , hide:this.permissions.includes('Approve'), headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
       
          },
          buttonIconClass: 'icon-edit',
          buttonVisible :true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log("Row clicked :" + param.data.id);
          },
          buttonIconClass: 'icon-book',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data.name);
            
            
          },
          buttonIconClass: 'icon-rotate-ccw',
          buttonVisible :false
        },
      ]
    },
  ];


  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  constructor() { }

  ngOnInit(): void {
    this.formula = "priority * slabAmount * maxAmount + 100";
  }

  onPaginationChange(param: PaginationChangedEvent | any) {

    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();


    console.log("selected pageSize export : " + this.pageSize);
    this.pageNumber = (param-1);
    console.log("selected pageNumber export : " + this.pageNumber);
    // this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,this.pageNumber)
    //   .subscribe((data:any) => (this.rowData = data.content,
    //     this.collectiondata = data.content,
    //     this.collectionSize = data.totalElements,
    //     this.gridApi.applyTransaction({ add: this.rowData })));
    // console.log("Collection Size : " + this.collectionSize);

  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
   
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    // this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,0)
    //   .subscribe((data:any) => (this.rowData = data.content,
    //     this.collectiondata = data.content,
    //     this.collectionSize = data.totalElements,
    //     this.gridApi.applyTransaction({ add: this.rowData })));
    // console.log("Collection Size : " + this.collectionSize);

  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.permissions == "View") {
      this.gridColumnApi.setColumnsVisible(["actions"], false);
    }
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);

    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    this.rowData = [];
    // return this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,0)
    //   .subscribe((data:any) => {
    //     console.log(data);
    //     this.rowData = data.content;
    //     console.log(" this.rowData= merchant masterlist===" + JSON.stringify(this.rowData))
    //     this.collectiondata = data.content,
    //       this.collectionSize = data.totalElements,
    //       console.log("Collection Size : " + this.collectionSize);

    //   });

  }
  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event: any) {
    const listOfSortModel = this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }

}
